export enum Roles {
    SENIOR = 'PATIENT',
    FAMILY = 'FAMILY',
    PRO = 'THERAPIST',
    ADMIN = 'ADMIN'
}
